import Skeleton from 'components/3catinfo/Skeleton/Skeleton';
import styles from './destacatBasic.module.scss';

const DestacatBasicSkeleton = (props) => {
    return (
        <div>
            <section className={styles.cos}>
                <div className={`${styles.imatgeWrapper} ${styles.imatgeSkeleton}`}>
                    <Skeleton imatge />
                </div>

                <Skeleton titol className={styles.titol} num={3} />
            </section>
        </div>
    );
};

export default DestacatBasicSkeleton;
